const isText = RegExp(/^[A-Z ]+$/i);
const isNumber = RegExp(/^\d+$/);

const focusFirstError = (form, conditionalCallback) => {
  if (!form) return;
  const fields = Object.keys(form);
  for (let i = 0, len = fields.length; i < len; i++) {
    const key = fields[i];
    const currentField = form[key];
    if (conditionalCallback(currentField)) {
      currentField.focus();
      break;
    }
  }
};

const thousandsFormatter = (num) => {
  if (num > 999 && num < 1000000) {
    return `${parseFloat((num / 1000).toFixed(1))}K`;
  } if (num >= 1000000) {
    return `${parseFloat((num / 1000000).toFixed(1))}M`;
  } if (num <= 999) {
    return parseFloat(num);
  }
  return null;
};

const numberWithCommas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const openUrl = (url, target = '_blank') => {
  const a = document.createElement('a');
  a.href = url;
  a.setAttribute('target', target);
  a.click();
};

const scrollVertically = (pos = 870, time = 250) => {
  const currentPos = window.pageYOffset;
  let start = null;
  if (!time) {
    time = 500;
  }
  pos = +pos;
  time = +time;

  const step = (currentTime) => {
    start = !start ? currentTime : start;
    const progress = currentTime - start;
    if (currentPos < pos) {
      window.scrollTo(0, ((pos - currentPos) * (progress / time)) + currentPos);
    } else {
      window.scrollTo(0, currentPos - ((currentPos - pos) * (progress / time)));
    }
    if (progress < time) {
      window.requestAnimationFrame(step);
    } else {
      window.scrollTo(0, pos);
    }
  };

  window.requestAnimationFrame(step);
};

export {
  isText, isNumber, focusFirstError, numberWithCommas, thousandsFormatter, openUrl, scrollVertically,
};
